// @ts-ignore
import webvarsConfigurationService from 'common/services/webvarsConfigurationService'
// @ts-ignore
import {createLogger as createPowtoonLogger} from 'powtoon-commons/logger'

const {getWebVar} = webvarsConfigurationService
const logzioId = getWebVar('logzioId')
const logzioMetricsId = getWebVar('logzioMetricsId')
const logzioUrl = getWebVar('logzioUrl')
const isProdEnv = getWebVar('isProdEnv')
let userId: string

const data = {
  logzioId,
  logzioMetricsId,
  logzioUrl,
  appName: process.env.ENTRY_POINT_NAME,
  appVersion: process.env.BUILD_IDENTIFIER,
  get userId() {
    return userId || 'n.a'
  },
  set userId(value) {
    userId = value
  }
}

const logConfig = {
  logLocally: !isProdEnv,
  logRemotely: !!logzioId
}

export const createLogger = (moduleName: string, loggerName = '') =>
  createPowtoonLogger({moduleName, loggerName}, data, logConfig)
